export default "__VITE_ASSET__CeiZM3hy__"